export const getPartnerHref = (shortcode: string, featureFlags: Record<string, string>) => {
  return featureFlags.partner_link === 'partner_product_list'
    ? `/partners/${shortcode}/products`
    : `/${shortcode}`;
};
